var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content content--quiz"},[_c('MyHeader',{attrs:{"breadcrumbItems":[

      {
        name: _vm.section.name,
        path: ("/" + (_vm.$route.params.companySlug) + "/quizzes")
      },
      {
        name: _vm.quiz.name,
        path: _vm.$route.path
      }
    ]}}),_c('div',{staticClass:"container main-content"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }